export default __webpack_public_path__ + "static/media/docker_kubernetes.be4c37e6.png";